var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8042 6.18652C11.9536 6.03823 12.1924 6.03854 12.3413 6.1875L17.1655 11.0352L17.2202 11.1006C17.2654 11.1667 17.2827 11.2356 17.2827 11.3047V17.5439C17.2827 17.7252 17.1336 17.907 16.9204 17.9072H13.272C13.0887 17.9072 12.9152 17.7576 12.8862 17.5547L12.8843 17.5439H12.8853V15.1201C12.8851 14.6097 12.4866 14.2109 11.9761 14.2109C11.4656 14.2109 11.067 14.6097 11.0669 15.1201V17.5439C11.0669 17.7253 10.917 17.9072 10.7036 17.9072H7.05615C6.87483 17.9072 6.69287 17.7573 6.69287 17.5439V11.3047C6.69287 11.254 6.70946 11.2008 6.72998 11.1562C6.75075 11.1113 6.77937 11.0668 6.81104 11.0352L6.81201 11.0342L11.8042 6.18652ZM7.44287 11.4795V17.1572H10.3413V15.1201C10.3415 14.2148 11.0952 13.4609 12.0005 13.4609C12.9056 13.4612 13.6585 14.215 13.6587 15.1201V17.1816H16.5571V11.4795L12.0708 6.99316L7.44287 11.4795Z",
    fill: "currentColor",
    stroke: "#181D27",
    strokeWidth: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.6146201a942ee4f294340b020de87281.svg";
export { ForwardRef as ReactComponent };